import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import authReducer from "./auth";
import roleManagementReducer from "./roleManagementReducer";
import organizationReducer from "./organizationReducer";
import organizationUsersReducer from "./organizationUserReducer";
import organizationBillingReducer from "./organizationBillingReducer";
import industryManagementReducer from "./industryManagementReducer";
import permissionManagementReducer from './permissionManagementReducer';
import accessControlManagementReducer from './accessControlManagementReducer';
import subscriptionReducer from './subscriptionReducer';
import scopeDocsReducer from './scopeDocReducer';
import swmsReducer from './swmsReducer';
import clientManagementReducer from './clientManagementReducer'
import jobCalenderReducer from "./jobCalendarReducer";
import equipmentManagementReducer from './equipmentManagementReducer'
import jobDocReducer from "./jobDocReducer";
import sAJobMgmtReducer from './SAJobMgmtReducer';
import serviceAgentJobCalendarReducer from './serviceAgentJobCalendarReducer';
import jobReducer from './jobReducer';
import profileManagementReducer from "./profileManagementReducer"
import sAIncidentReportReducer from './SAIncidentReportReducer'
import completedJobManagementReducer from './jobManagementReducer'
import timeSheetReducer from './timeSheetReducer'
import jobManagerReducer from "./jobManagerReducer";
import staffCalendarReducer from './staffCalendarReducer'
import invoiceReducer from "./invoiceReducer";
import emailTemplateReducer from "./emailTemplateReducer";
import smsTemplateReducer from "./smsTemplateReducer";
import inductionTrainingReducer from "./inductionTrainingReducer";
import advanceSeacrhReducer from './advanceSearchReducer'
import broadcastReducer from "./broadcastReducer"
import likelyhoodBeforeControlReducer from './likelyhoodBeforeControlReducer';
import consequenceBeforeReducer from './consequenceBeforeReducer';

import adminTimesheetReducer from './adminTimeSheetReducer'

import bookingCalendarReducer from './bookingCalendarReducer'
import jobDocumentsReducer from './jobDocumentsReducer';
import jobDetailsReducer from './jobDetailsReducer';
import payRateReducer from './payRateReducer';
import payrollTimesheetReducer from './payrollTimesheetReducer';
import SWMSMastersReducer from './SWMSMastersReducer';
import reportManagementReducer from './reportManagementReducer'

import JobCalendarReducer from './v2/JobCalendarReducer';
import AllocationsReducer from './v2/AllocationsReducer';
import JobDocumentReducer from './v2/JobDocumentReducer';
import JobReducer from "./v2/JobReducer";
import ContractorsReducer from "./v2/ContractorsReducers";
import QuotesReducer from "./v2/QuotesReducer";
import SiteManagementReducer from "./v2/SiteManagementReducer";
import RfqReducer from "./v2/RfqReducer";
import CalendarReducer from "./v2/CalendarReducer";
import TimesheetsReducer from "./v2/TimesheetsReducer";
import RosteringReducer from "./v2/RosteringReducer";
import SwmsMethodItemsReducer from "./v2/SwmsMethodItemsReducer";
import SwmsMethodsReducer from "./v2/SwmsMethodsReducer";
import SwmsCategoryFiltersReducer from "./v2/SwmsCategoryFiltersReducer";
import PdfTemplatesReducer from "./v2/PdfTemplatesReducer";
import EmailTemplatesReducer from "./v2/EmailTemplatesReducer";

const appReducer = combineReducers({
  form: formReducer,
  auth: authReducer,
  roleManagement: roleManagementReducer,
  organization: organizationReducer,
  organizationUsers: organizationUsersReducer,
  organizationBilling: organizationBillingReducer,
  industryManagement: industryManagementReducer,
  permissionByRoleManagement: permissionManagementReducer,
  accessControlManagement: accessControlManagementReducer,
  subscription: subscriptionReducer,
  scopeDocs: scopeDocsReducer,
  swmsReducer: swmsReducer,
  clientManagement: clientManagementReducer,
  jobsManagement: jobCalenderReducer,
  equipmentManagement: equipmentManagementReducer,
  jobdocManagement: jobDocReducer,
  sAJobMgmt: sAJobMgmtReducer,
  sAJobCalendar: serviceAgentJobCalendarReducer,
  jobManagement: jobReducer,
  profileManagement: profileManagementReducer,
  sAIncidentManagement: sAIncidentReportReducer,
  completedJobManagement: completedJobManagementReducer,
  timeSheet: timeSheetReducer,
  jobManger: jobManagerReducer,
  staffCalendar: staffCalendarReducer,
  invoice: invoiceReducer,
  emailTemplate: emailTemplateReducer,
  smsTemplate: smsTemplateReducer,
  inductionTraining: inductionTrainingReducer,
  advanceSeacrh: advanceSeacrhReducer,
  broadCast: broadcastReducer,
  likelyhoodBeforeControl: likelyhoodBeforeControlReducer,
  beforeConsequenceControl: consequenceBeforeReducer,

  adminTimesheet: adminTimesheetReducer,
  bookingCalendar: bookingCalendarReducer,
  jobDocuments: jobDocumentsReducer,
  jobDetailsReducer: jobDetailsReducer,
  payRateReducer: payRateReducer,
  payrollReducer: payrollTimesheetReducer,
  SWMSMasters: SWMSMastersReducer,
  reportManagement: reportManagementReducer,

  JobCalendar: JobCalendarReducer,
  Allocations: AllocationsReducer,
  JobDocument: JobDocumentReducer,
  Job: JobReducer,
  Contractors: ContractorsReducer,
  Quotes: QuotesReducer,
  Sites: SiteManagementReducer,
  Rfq: RfqReducer,
  Calendar: CalendarReducer,
  TimesheetsV2: TimesheetsReducer,
  Roster: RosteringReducer,
  swmsMethodItems: SwmsMethodItemsReducer,
  swmsMethods: SwmsMethodsReducer,
  swmsCategoryFilters: SwmsCategoryFiltersReducer,
  pdfTemplates: PdfTemplatesReducer,
  emailTemplates: EmailTemplatesReducer
});

export default (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined
  }
  return appReducer(state, action)
}
